import { HeatingCircuit, } from 'z3k-config';
import { addRest, getValue, nonZero, number_or_0, objectid_array_or_empty, objectid_or_0, objectid_or_null, string_or_empty, } from '../../utils/parser-utils';
import { ObjectLine } from 'z3k-parser/parser/utils/object-line';
const heating_circuit_fields = [
    { name: 'name', ...string_or_empty },
    { name: 'type', ...number_or_0 },
    { name: 'water_min_temperature', ...number_or_0 },
    { name: 'water_max_temperature', ...number_or_0 },
    { name: 'air_temp_sensor', ...objectid_or_null },
    { name: 'air_temp_sensor_reserve', ...objectid_or_null },
    { name: 'dhw_temp_sensor', ...objectid_or_null },
    { name: 'dhw_temp_sensor_reserve', ...objectid_or_null },
    { name: 'water_temp_sensor', ...objectid_or_null },
    { name: 'water_temp_sensor_reserve', ...objectid_or_null },
    { name: 'hysteresis', ...number_or_0 },
    { name: 'control_devices', ...objectid_array_or_empty },
    { name: 'setting_register', ...number_or_0 },
    { name: 'turn_off_delay', ...number_or_0 },
    { name: 'external_thermostat', ...objectid_or_null },
    { name: 'heat_request', ...number_or_0 },
    { name: 'pza', ...objectid_or_null },
    { name: 'heat_source', ...number_or_0 },
    // {name: 'antileg_mode_options', ...number_or_0},
    { name: 'summer_threshold', ...number_or_0 },
    // {name: 'winter_summer_switch', ...number_or_0},
    { name: 'position', ...number_or_0 },
    { name: 'locker_id', ...objectid_or_0 },
    { name: 'delta_temp', ...number_or_0 },
    { name: 'air_alarm_temp', ...number_or_0 },
    { name: 'pid_prop_koef', ...number_or_0 },
    { name: 'pid_integral_koef', ...number_or_0 },
    { name: 'off_to_start_delay', ...number_or_0 },
    { name: 'start_to_off_delay', ...number_or_0 },
];
function heatingCircuits2Str(obj_id, obj) {
    const hc_type = Number(obj.type);
    const air_water_temp_sensor = hc_type === HeatingCircuit.Type.DHW
        ? obj.dhw_temp_sensor != null
            ? Number(obj.dhw_temp_sensor)
            : 0
        : obj.air_temp_sensor != null
            ? Number(obj.air_temp_sensor)
            : 0;
    const air_water_temp_sensor_reserve = hc_type === HeatingCircuit.Type.DHW
        ? obj.dhw_temp_sensor_reserve != null
            ? Number(obj.dhw_temp_sensor_reserve)
            : 0
        : obj.air_temp_sensor_reserve != null
            ? Number(obj.air_temp_sensor_reserve)
            : 0;
    const setting_register = obj.setting_register || 0;
    const antileg_mode_options = obj.antileg_mode_options || { m: 0, h: 0, days: 0 };
    let pza = Number(obj.pza || 0);
    if (pza <= 10) {
        pza = Math.round(pza * 10);
    }
    else {
        pza = Number(pza);
    }
    return new ObjectLine(obj.id, obj_id, [
        obj.name,
        hc_type,
        obj.water_min_temperature != null
            ? Math.round((Number(obj.water_min_temperature) + 273) * 10)
            : 0,
        obj.water_max_temperature != null
            ? Math.round((Number(obj.water_max_temperature) + 273) * 10)
            : 0,
        air_water_temp_sensor,
        air_water_temp_sensor_reserve,
        obj.water_temp_sensor != null ? Number(obj.water_temp_sensor) : 0,
        obj.water_temp_sensor_reserve != null
            ? Number(obj.water_temp_sensor_reserve)
            : 0,
        Math.round(obj.hysteresis * 10),
        obj.control_devices,
        setting_register,
        Math.round(obj.turn_off_delay * 1000),
        obj.external_thermostat != null ? Number(obj.external_thermostat) : 0,
        Number(obj.heat_request),
        pza,
        (obj.heat_source || null) != null ? Number(obj.heat_source) : 0,
        antileg_mode_options['m'] +
            (antileg_mode_options['h'] << 8) +
            (antileg_mode_options['days'] << 16),
        hc_type > 1 && (obj.winter_summer_switch || false)
            ? Math.round(((obj.summer_threshold || -273) + 273) * 10)
            : 0,
        obj.position || 0,
        obj.locker_id != null ? obj.locker_id : 0,
        obj.delta_temp || 0,
        obj.air_alarm_temp != null
            ? Math.round((Number(obj.air_alarm_temp) + 273) * 10)
            : 3230,
        obj.pid_prop_koef != null ? Number(obj.pid_prop_koef) * 10 : 100,
        obj.pid_integral_koef != null ? Number(obj.pid_integral_koef) * 10 : 10,
        obj.off_to_start_delay != null ? Number(obj.off_to_start_delay) : 0,
        obj.start_to_off_delay != null ? Number(obj.start_to_off_delay) : 0,
        ...(obj.rest || []),
    ]);
}
function nonZeroTemp(array, index, dflt = 0) {
    const val = nonZero(array, index, dflt);
    return val != null ? val / 10 - 273 : null;
}
function heatingCircuitsFromStr(id, params) {
    const hc_type = Number(params[1]);
    const is_dhw_type = hc_type === HeatingCircuit.Type.DHW;
    const antileg_mode_options = getValue(params, 16, 0);
    let pza = Number(params[14]);
    if (0 < pza && pza <= 100) {
        pza /= 10;
    }
    const air_alarm_temp = params[21];
    return {
        id: id,
        name: params[0],
        type: hc_type,
        water_min_temperature: is_dhw_type ? null : +params[2] / 10 - 273,
        water_max_temperature: is_dhw_type ? null : +params[3] / 10 - 273,
        air_temp_sensor: params[4] == 0 || is_dhw_type ? null : +params[4],
        air_temp_sensor_reserve: params[5] == 0 || is_dhw_type ? null : params[5],
        dhw_temp_sensor: params[4] == 0 || !is_dhw_type ? null : params[4],
        dhw_temp_sensor_reserve: params[5] == 0 || !is_dhw_type ? null : params[5],
        water_temp_sensor: params[6] == 0 ? null : params[6],
        water_temp_sensor_reserve: params[7] == 0 ? null : params[7],
        hysteresis: params[8] / 10,
        control_devices: params[9],
        setting_register: +params[10],
        turn_off_delay: params[11] / 1000,
        external_thermostat: nonZero(params, 12),
        heat_request: Number(params[13]),
        pza: pza,
        heat_source: nonZero(params, 15),
        antileg_mode_options: {
            m: antileg_mode_options & ((1 << 8) - 1),
            h: (antileg_mode_options >> 8) & ((1 << 8) - 1),
            days: (antileg_mode_options >> 16) & ((1 << 8) - 1),
        },
        summer_threshold: nonZeroTemp(params, 17),
        //@ts-ignore
        winter_summer_switch: getValue(params, 17, 0) > 0,
        position: getValue(params, 18, 0),
        locker_id: nonZero(params, 19),
        delta_temp: getValue(params, 20, 0),
        air_alarm_temp: air_alarm_temp != null ? air_alarm_temp / 10 - 273 : 50,
        pid_prop_koef: getValue(params, 22, 100) / 10,
        pid_integral_koef: getValue(params, 23, 10) / 10,
        off_to_start_delay: getValue(params, 24, 0),
        start_to_off_delay: getValue(params, 25, 0),
        ...addRest(params, 26),
    };
}
export const heating_circuit_parser = {
    toStr: heatingCircuits2Str,
    fromStr: heatingCircuitsFromStr,
};
